import { Reducer } from "redux";

import { GetDisciplineStatusListDispatchTypes } from "../models/dispatchTypes/Referral";
import { DisciplineStatusResponse } from "../models/api/Referral";
import { DisciplineListPayload } from "../models/PhysicianDetails";
import { GetDisciplineStatusListActionDispatchTypes } from "../constants/Referral";

const initialState: DisciplineStatusResponse = {
  loading: false,
  response: {} as DisciplineListPayload,
  error: null,
};

const DisciplineStatusReducer: Reducer<
DisciplineStatusResponse,
GetDisciplineStatusListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetDisciplineStatusListActionDispatchTypes.GET_DISCIPLINE_STATUS_LIST_RESET: {
      return initialState;
    }
  }
  return state;
};
export default DisciplineStatusReducer;
